module.exports = __webpack_public_path__ + "img/icons B_6.6a2a4a0e.svg";